<template>
  <div class="wrap-tracking">
    <div class="tracking-container">
      <div class="d-flex flex-column justify-content-center mh-100">
        <div class="tracking-content">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
